import { render } from "./ColorBackground.vue?vue&type=template&id=62b57347"
import script from "./ColorBackground.vue?vue&type=script&lang=js"
export * from "./ColorBackground.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__